import { render, staticRenderFns } from "./SettingsOpenQuestion.vue?vue&type=template&id=545b9710&scoped=true"
import script from "./SettingsOpenQuestion.vue?vue&type=script&lang=js"
export * from "./SettingsOpenQuestion.vue?vue&type=script&lang=js"
import style0 from "./SettingsOpenQuestion.vue?vue&type=style&index=0&id=545b9710&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "545b9710",
  null
  
)

export default component.exports